// Generated by CoffeeScript 2.7.0
var NextVertexAssignmentSetting;

import {
  ListSelect
} from './next_vertex.js';

import NextVertexSettingMixin from 'trunks/vue/share/mixins/yet_another_workflow/assignment_settings/next_vertex.js';

export default NextVertexAssignmentSetting = {
  mixins: [NextVertexSettingMixin],
  components: {
    'list-select': ListSelect
  },
  template: `<div class="inline form-field next-vertex-setting">
  <div class="form-field-head">
    <div class="form-field-title">选择回退节点</div>
  </div>
  <div class="form-field-input-container">
    <div class="form-field-input">
      <list-select :optionList='vertexlist'
                   :initValue='nextVertex'
                   extendClass='list-popover'
                   placeholder='任意'
                   @valueChanged='vertexSelectFunc' />
    </div>
  </div>
</div>`
};
